"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBuildPaymentEscrowPda = exports.getDeterministicIngredientPda = exports.getBuildPermitPda = exports.getPackPda = exports.getRecipePda = exports.getBuildPda = exports.getItemPda = exports.getItemClassPda = exports.PackContents = exports.convertToPaymentStatus = exports.PaymentStatus = exports.convertToBuildStatus = exports.BuildStatus = exports.parseItemClassMode = exports.formatItemClassModeSelection = exports.formatRecipeType = exports.convertToRecipeType = exports.RecipeType = exports.ITEMV2_ID = void 0;
const anchor_1 = require("@project-serum/anchor");
const js_sha256_1 = require("js-sha256");
exports.ITEMV2_ID = new anchor_1.web3.PublicKey("itEm2FtqJWqUmMTYrUxoFcmFtBxEpd68VTmxJamQXA3");
var RecipeType;
(function (RecipeType) {
    RecipeType[RecipeType["SimpleMint"] = 0] = "SimpleMint";
    RecipeType[RecipeType["SimpleBurn"] = 1] = "SimpleBurn";
    RecipeType[RecipeType["SimpleTransfer"] = 2] = "SimpleTransfer";
    RecipeType[RecipeType["Complex"] = 3] = "Complex";
})(RecipeType = exports.RecipeType || (exports.RecipeType = {}));
function convertToRecipeType(recipeTypeRaw) {
    const recipeTypeStr = JSON.stringify(recipeTypeRaw);
    if (!recipeTypeStr) {
        return RecipeType.Complex;
    }
    switch (true) {
        case recipeTypeStr.includes("simpleMint"):
            return RecipeType.SimpleMint;
        case recipeTypeStr.includes("simpleBurn"):
            return RecipeType.SimpleBurn;
        case recipeTypeStr.includes("simpleTransfer"):
            return RecipeType.SimpleTransfer;
        default:
            return RecipeType.Complex;
    }
}
exports.convertToRecipeType = convertToRecipeType;
function formatRecipeType(recipeType) {
    switch (recipeType) {
        case RecipeType.SimpleMint:
            return { simpleMint: {} };
        case RecipeType.SimpleBurn:
            return { simpleBurn: {} };
        case RecipeType.SimpleTransfer:
            return { simpleTransfer: {} };
        case RecipeType.Complex:
            return { complex: {} };
    }
}
exports.formatRecipeType = formatRecipeType;
function formatItemClassModeSelection(mode) {
    switch (mode.kind) {
        case "MerkleTree":
            return { merkleTree: {} };
        case "Collection":
            return { collection: { collectionMint: mode.collectionMint } };
        case "Pack":
            return { pack: {} };
        case "PresetOnly":
            return { presetOnly: {} };
    }
}
exports.formatItemClassModeSelection = formatItemClassModeSelection;
function parseItemClassMode(itemClassData) {
    let mode = { kind: "PresetOnly" };
    switch (Object.keys(itemClassData.mode)[0]) {
        case "pack":
            mode = {
                kind: "Pack",
                index: new anchor_1.BN(itemClassData.mode.pack.index),
            };
            break;
        case "merkleTree":
            mode = {
                kind: "MerkleTree",
                tree: new anchor_1.web3.PublicKey(itemClassData.mode.merkleTree.tree),
            };
            break;
        case "collection":
            mode = {
                kind: "Collection",
                collectionMint: new anchor_1.web3.PublicKey(itemClassData.mode.collection.collectionMint),
            };
            break;
        case "presetOnly":
            // this is the default selected above the switch func
            break;
        default:
            throw new Error(`unknown item class mode: ${itemClassData.mode}`);
    }
    return mode;
}
exports.parseItemClassMode = parseItemClassMode;
var BuildStatus;
(function (BuildStatus) {
    BuildStatus[BuildStatus["InProgress"] = 0] = "InProgress";
    BuildStatus[BuildStatus["Complete"] = 1] = "Complete";
    BuildStatus[BuildStatus["ItemReceived"] = 2] = "ItemReceived";
})(BuildStatus = exports.BuildStatus || (exports.BuildStatus = {}));
function convertToBuildStatus(buildStatusRaw) {
    const buildStatusStr = JSON.stringify(buildStatusRaw);
    switch (true) {
        case buildStatusStr.includes("inProgress"):
            return BuildStatus.InProgress;
        case buildStatusStr.includes("complete"):
            return BuildStatus.Complete;
        case buildStatusStr.includes("itemReceived"):
            return BuildStatus.ItemReceived;
        default:
            throw new Error(`Invalid Build Status: ${buildStatusRaw}`);
    }
}
exports.convertToBuildStatus = convertToBuildStatus;
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["NotPaid"] = 0] = "NotPaid";
    PaymentStatus[PaymentStatus["Escrowed"] = 1] = "Escrowed";
    PaymentStatus[PaymentStatus["SentToTreasury"] = 2] = "SentToTreasury";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
function convertToPaymentStatus(paymentStatusRaw) {
    const paymentStatusStr = JSON.stringify(paymentStatusRaw);
    switch (true) {
        case paymentStatusStr.includes("notPaid"):
            return PaymentStatus.NotPaid;
        case paymentStatusStr.includes("escrowed"):
            return PaymentStatus.Escrowed;
        case paymentStatusStr.includes("sentToTreasury"):
            return PaymentStatus.SentToTreasury;
        default:
            throw new Error(`Invalid Payment Status: ${paymentStatusRaw}`);
    }
}
exports.convertToPaymentStatus = convertToPaymentStatus;
class PackContents {
    constructor(entries, nonce) {
        if (nonce.length !== 16) {
            throw new Error(`nonce must be 16 bytes`);
        }
        this.nonce = nonce;
        this.entries = entries;
    }
    hash() {
        // match this with the program code
        const contentBuffers = this.entries.map((entry) => Buffer.concat([
            entry.mint.toBuffer(),
            entry.amount.toArrayLike(Buffer, "le", 8),
        ]));
        const digest = js_sha256_1.sha256.digest(Buffer.concat([...contentBuffers, Buffer.from(this.nonce)]));
        const hash = Buffer.from(digest);
        return hash;
    }
}
exports.PackContents = PackContents;
function getItemClassPda(authorityMint) {
    const [itemClass, _itemClassBump] = anchor_1.web3.PublicKey.findProgramAddressSync([Buffer.from("item_class"), authorityMint.toBuffer()], exports.ITEMV2_ID);
    return itemClass;
}
exports.getItemClassPda = getItemClassPda;
function getItemPda(itemMint) {
    const [item, _itemBump] = anchor_1.web3.PublicKey.findProgramAddressSync([Buffer.from("item"), itemMint.toBuffer()], exports.ITEMV2_ID);
    return item;
}
exports.getItemPda = getItemPda;
function getBuildPda(itemClass, builder) {
    const [build, _buildBump] = anchor_1.web3.PublicKey.findProgramAddressSync([Buffer.from("build"), itemClass.toBuffer(), builder.toBuffer()], exports.ITEMV2_ID);
    return build;
}
exports.getBuildPda = getBuildPda;
function getRecipePda(itemClass, recipeIndex) {
    const [recipe, _recipeBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
        Buffer.from("recipe"),
        recipeIndex.toArrayLike(Buffer, "le", 8),
        itemClass.toBuffer(),
    ], exports.ITEMV2_ID);
    return recipe;
}
exports.getRecipePda = getRecipePda;
function getPackPda(itemClass, id) {
    const [pack, _packBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
        Buffer.from("pack"),
        itemClass.toBuffer(),
        id.toArrayLike(Buffer, "le", 8),
    ], exports.ITEMV2_ID);
    return pack;
}
exports.getPackPda = getPackPda;
function getBuildPermitPda(builder, itemClass) {
    const [buildPermit, _buildPermitBump] = anchor_1.web3.PublicKey.findProgramAddressSync([Buffer.from("build_permit"), builder.toBuffer(), itemClass.toBuffer()], exports.ITEMV2_ID);
    return buildPermit;
}
exports.getBuildPermitPda = getBuildPermitPda;
function getDeterministicIngredientPda(itemClass, ingredientMint) {
    const [deterministicIngredient, _deterministicIngredientBump] = anchor_1.web3.PublicKey.findProgramAddressSync([
        Buffer.from("deterministic_ingredient"),
        itemClass.toBuffer(),
        ingredientMint.toBuffer(),
    ], exports.ITEMV2_ID);
    return deterministicIngredient;
}
exports.getDeterministicIngredientPda = getDeterministicIngredientPda;
function getBuildPaymentEscrowPda(build) {
    const [buildPaymentEscrow, _buildPaymentEscrow] = anchor_1.web3.PublicKey.findProgramAddressSync([Buffer.from("build_payment_escrow"), build.toBuffer()], exports.ITEMV2_ID);
    return buildPaymentEscrow;
}
exports.getBuildPaymentEscrowPda = getBuildPaymentEscrowPda;
